

export const commonEnv = {
  layerConfig:'assets/config/layers.json',
  basemapConfig:'assets/config/basemaps.json',
  vectorConfig:'assets/config/foci.json',
  tours:'assets/config/no-tours.json',
  tds:'https://thredds.nci.org.au/thredds',
  terrakio:'https://api.terrak.io',
  // terrakio:'http://localhost:8080/service',
  // terrakio:'http://localhost:3129',
  terrakioWMS:'wms',
  // terrakioTiles:'https://wms.globalwater.online',
  terrakioTiles:'https://terrakio-tiles.hydrograph.io',
  terrakioWCS:'wcs',
  terrakioKey:'',
  // terrakio: 'https://terrakio-dev-d4w6vamyxq-ts.a.run.app',
  pointConfig:'assets/config/points.json',
  geojsons: 'assets/selection_layers/',
  attributeTranslations:'assets/lookups.json',
  // tiles:'https://storage.googleapis.com/wald-vector/{{filename}}/{z}/{x}/{y}.pbf',
  tiles:'https://storage.googleapis.com/terrakio-vector/GWM/{{tileSource}}/{z}/{x}/{y}.pbf',
  spatialDownloads: false,
  feedbackAddress: 'info@hydrograph.io',
  dashboard: 'not set',
  dashboards: 'assets/config/dashboards.json',
  fontFamily: 'Roboto, Open Sans, sans-serif',
  maxPointSites: 2500
};

  